import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AddBoxIcon from '@mui/icons-material/AddBox';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import Co2Icon from '@mui/icons-material/Co2';
import AssessmentTwoToneIcon from '@mui/icons-material/AssessmentTwoTone';
import RouteIcon from '@mui/icons-material/Route';

const publicMenuItems = (pmdProjectItems) => [
  {
    heading: 'General',
    items: [
      { name: 'Home', icon: HomeRoundedIcon, link: '/' },
      {
        name: 'Policy Monitoring',
        icon: AssessmentTwoToneIcon,
        items: [
          {
            name: 'Browse the map',
            link: '/dashboards/policy-monitoring',
            icon: TravelExploreOutlinedIcon,
          },
          ...pmdProjectItems,
        ],
      },
      {
        name: 'Dynamic Exposure Visualisation',
        link: '/dashboards/dev-d',
        icon: RouteIcon,
      },
      {
        name: 'Carbon Footprint',
        link: 'dashboards/carbon-footprint',
        icon: Co2Icon,
      },
    ],
  },
];

const adminMenuItems = (pmdProjectItems) => [
  {
    heading: 'General',
    items: [
      { name: 'Home', icon: HomeRoundedIcon, link: '/' },
      {
        name: 'Policy Monitoring',
        icon: AssessmentTwoToneIcon,
        items: [
          {
            name: 'Browse the map',
            link: '/dashboards/policy-monitoring',
            icon: TravelExploreOutlinedIcon,
          },
          ...pmdProjectItems,
          {
            name: 'Create project',
            link: '/dashboards/policy-monitoring/create-project',
            icon: AddBoxIcon,
          },
        ],
      },
      {
        name: 'Dynamic Exposure Visualisation',
        link: '/dashboards/dev-d',
        icon: RouteIcon,
      },
      {
        name: 'Carbon Footprint',
        link: 'dashboards/carbon-footprint',
        icon: Co2Icon,
      },
    ],
  },
  {
    heading: 'Management',
    items: [
      {
        name: 'User Management',
        icon: AssignmentIndTwoToneIcon,
        link: 'management/users/users-management',
      },
    ],
  },
];

// map router menu items to roles
const menuItems = {
  user: publicMenuItems,
  admin: adminMenuItems,
  guest: publicMenuItems,
};

export default menuItems;
